import React from 'react';
import intl from 'react-intl-universal';

import type { ArticleType } from '@/type/article';

import styles from './index.module.less';

interface Props {
    articleData: ArticleType;
}

const Statement: React.FC<Props> = ({ articleData }) => {
    const { is_original = '' } = articleData || {};

    return (
        <div className={styles.statement}>
            {/* 原创标签 */}
            {is_original === '1' ? (
                <p className={styles.original}>·{intl.get('Article.OriginalArticle').d('原创文章')}</p>
            ) : (
                <React.Fragment />
            )}
            <p>
                {intl
                    .get('Common.Disclaimer')
                    .d(
                        '免责声明：本文观点来自原作者，不代表Hawk Insight的观点和立场。文章内容仅供参考、交流、学习，不构成投资建议。如涉及版权问题，请联系我们删除。',
                    )}
            </p>
        </div>
    );
};

export default Statement;
